import * as React from "react";
import Select from "react-select";
import { TemperatureUnitContext } from "../../context/app-context";
import { selectTheme, styles } from "../../services/selectTheme";
import { Switch } from "@mui/material";

export const TemperatureUnitPicker = () => {
    const [unit, setUnit] = React.useContext(TemperatureUnitContext);

    return (
        <div className="flex items-center gap-[4px] xsm:gap-[8px]">
            <span
                className={`text-[13px] leading-none xsm:text-sm ${
                    unit === "C" ? "font-bold" : ""
                }`}
            >
                °C
            </span>
            <Switch
                checked={unit === "F"}
                className=""
                onChange={(e, checked) => setUnit(checked ? "F" : "C")}
            />
            <span
                className={`text-[13px] leading-none xsm:text-sm ${
                    unit === "F" ? "font-bold" : ""
                }`}
            >
                °F
            </span>
        </div>
    );
};
